import { createContext, useContext } from 'react';

import { MediaPlan } from '@mint-sdk/api-media-plan';

type DeleteMediaDataContextValue = (mediaData: MediaPlan.MediaData) => void;

export const DeleteMediaDataContext =
  createContext<DeleteMediaDataContextValue | null>(null);

export const useSetMediaDataToDelete = () => {
  const setMediaDataToDelete = useContext(DeleteMediaDataContext);

  if (!setMediaDataToDelete) {
    throw new Error(
      'useSetMediaDataToDelete must be used within a DeleteMediaDataProvider',
    );
  }

  return setMediaDataToDelete;
};
